import { splitArrayChunks } from '../utils'
import ResolutionContenu from './ResolutionContenu'
import ResolutionTitle from './ResolutionTitle'

export const BaseUnit = (props) => (
  <div style={{ breakInside: 'avoid', ...(props.style ? props.style : {}) }}>
    {props.children}
  </div>
)
const IntroResolutions = ({ record }) => {
  var block_length = 20
  var chunks = splitArrayChunks(
    record.resolutions ? record.resolutions : [],
    block_length
  )
  return (
    <div>
      {chunks?.map((c, i1) => {
        return (
          <>
            {c.map((e, i2) => {
              return (
                <div key={i2}>
                  <ResolutionTitle record={e} />
                  <ResolutionContenu record={e} />
                </div>
              )
            })}
          </>
        )
      })}
    </div>
  )
}
export default IntroResolutions
